import React from 'react';

import { HelpOnTheRoadContextType } from './types';

export const HelpOnTheRoadContext = React.createContext(
  {} as HelpOnTheRoadContextType
);
